import * as React from "react";
import Box from "@mui/material/Box";

import Modal from "@mui/material/Modal";
import Address from "../loginDashboard/address/Address";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 700,
  bgcolor: "background.paper",
  borderRadius: 2,
  boxShadow: 24,
  p: 4,
  maxWidth: "90%",
};

export default function AddressModal({ setOpen, open, handleClose }) {
  return (
    <div>
      <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={style} className="address-modal">
          <Address isModal handleClose={handleClose} setOpen={setOpen} />
        </Box>
      </Modal>
    </div>
  );
}
